import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const LOGIN_BG = "https://images.unsplash.com/photo-1769283979351-13b3690897d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwYXJjaGl0ZWN0dXJlJTIwYnVpbGRpbmclMjBmYWNhZGV8ZW58MHx8fHwxNzczOTM0MzExfDA&ixlib=rb-4.1.0&q=85";
const MBS_LOGO = "https://customer-assets.emergentagent.com/job_admit-track-2/artifacts/ug5k3pex_Screenshot%202026-03-19%20at%2010.10.51%E2%80%AFPM.png";

export default function LoginPage() {
  const { user } = useAuth();
  if (user) return <Navigate to="/dashboard" replace />;

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 relative overflow-hidden items-center justify-center">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: `url(${LOGIN_BG})` }} />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/80 to-slate-900/40" />
        <div className="relative z-10 text-center px-12 space-y-6">
          <img src={MBS_LOGO} alt="MBS College" className="h-32 mb-6 object-contain" />
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white/70 text-xs font-medium tracking-wider uppercase mb-4">
            Admissions Portal
          </div>
          <p className="text-lg text-slate-300 font-light">AI Ready Minds for Tomorrow's Industry</p>
          <div className="flex items-center justify-center gap-4 mt-8 text-sm text-slate-400 flex-wrap">
            <span>B.Arch</span>
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span>B.Design</span>
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span>BCom</span>
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span>BBA</span>
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span>BCA</span>
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span>BTech</span>
          </div>
        </div>
      </div>

      {/* Right panel */}
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md space-y-8">
          <div className="lg:hidden text-center mb-8">
            <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>MBS College</h1>
            <p className="text-sm text-slate-500 mt-1">Admissions CRM</p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-8 shadow-sm space-y-6">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>Welcome Back</h2>
              <p className="text-slate-500 text-sm mt-2">Sign in to access the admissions portal</p>
            </div>

            <Button
              onClick={handleGoogleLogin}
              className="w-full py-6 text-sm font-semibold bg-slate-900 hover:bg-slate-800 rounded-lg"
              data-testid="google-login-btn"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google
            </Button>
          </div>

          <p className="text-center text-xs text-slate-400">
            Dwarka, New Delhi &middot; Affiliated to GGSIPU
          </p>
        </div>
      </div>
    </div>
  );
}
